
export default {
  recshareMembers: [],
  recshare: 0,
  total:0,
  max:10,
  offset:0,
  sort: 'id',
  order: 'ascending'
};
